// extracted by mini-css-extract-plugin
export default {"viewToggle":"ResultsViewSwitch_viewToggle__fjNoa","viewOption":"ResultsViewSwitch_viewOption__h2MGg","active":"ResultsViewSwitch_active__pfDZt"};